import React from 'react';

const Video = ({ src, className, poster, preload = 'none', ...props }) => {
    return src ? (
        <video className={className} controls poster={poster} preload={preload}>
            <source src={src} type="video/mp4" />
            <track kind="captions" />
        </video>
    ) : (
        <p>Bideo fitxategiaren helbidea falta da</p>
    );
};

export default Video;
